import { render, staticRenderFns } from "./OrderStats.vue?vue&type=template&id=75266463&scoped=true&"
import script from "./OrderStats.vue?vue&type=script&lang=js&"
export * from "./OrderStats.vue?vue&type=script&lang=js&"
import style0 from "./OrderStats.vue?vue&type=style&index=0&id=75266463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75266463",
  null
  
)

export default component.exports